module.exports = __webpack_public_path__ + "static/media/guatemala.9570f46d.svg";